module.exports = __webpack_public_path__ + "img/yonaga.a6f7998d.jpg";